import { createElement, Suspense, use, type ReactNode } from 'react'

export function appRoot(element: ReactNode | Promise<ReactNode>) {
  function Content() {
    return element instanceof Promise ? use(element) : element
  }
  return function Root() {
    return createElement(Suspense, { fallback: null }, createElement(Content))
  }
}
